export enum RequestType {
  provide = "provide",
  confirm = "confirm",
  change = "change",
  delete = "delete",
  internal = "Internal",
  external = "External",
  evict = "evict",
}

export const requestTypes: { [key: string]: string } = {
  [RequestType.provide]: "Cấp mới",
  [RequestType.confirm]: "Xác nhận",
  [RequestType.change]: "Thay đổi",
  [RequestType.delete]: "Xóa",
  [RequestType.internal]: "Nội bộ",
  [RequestType.external]: "Bên ngoài",
  [RequestType.evict]: "Thu hồi",
};

export const requestTypeDetail: {
  [key in RequestType]: { label: string; flag?: string };
} = {
  [RequestType.provide]: {
    label: "Cấp mới",
    flag: "success",
  },
  [RequestType.confirm]: {
    label: "Xác nhận",
    flag: "success",
  },
  [RequestType.change]: {
    label: "Thay đổi",
    flag: "warning",
  },
  [RequestType.delete]: {
    label: "Xóa",
    flag: "danger",
  },
  [RequestType.internal]: {
    label: "Nội bộ",
    flag: "success",
  },
  [RequestType.external]: {
    label: "Bên ngoài",
    flag: "danger",
  },
  [RequestType.evict]: {
    label: "Thu hồi",
    flag: "success",
  },
};
